import React, { useEffect } from "react";

import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { NoomMedOverviewSelection, ProgramOffering } from "@/constants";
import { useAppContext } from "@/contexts";
import { useTrackEvent } from "@/hooks";

import { ProgramResult } from "./programResult/ProgramResult";

const QUESTION_ID = "noomMedOverview";

declare module "@/contexts" {
  interface SurveyAnswers {
    noomMedOverview?: NoomMedOverviewSelection;
    updatedProgram?: ProgramOffering | null;
    wasOfferedMed?: boolean;
  }
}

const NoomMedOverviewQuestion: React.FC<QuestionComponentProps> = ({
  onClickNext,
  surveyAnswers,
}) => {
  const {
    enrollmentType,
    retriageEligibility,
    partnerInfo,
    setSelectedProgram,
    setSurveyAnswers,
  } = useAppContext();
  const { trackAnonEvent } = useTrackEvent();

  const currentProgram =
    enrollmentType === "RETRIAGE"
      ? retriageEligibility?.currentProgram
      : undefined;
  const isAccolade = partnerInfo?.configs?.ACCOLADE_PARTNER || false;

  const handleJoinMed = (selection: NoomMedOverviewSelection) => {
    const updatedProgram: ProgramOffering = isAccolade ? "NMPBA" : "MED";

    setSelectedProgram(updatedProgram);
    onClickNext(selection, {
      updatedProgram,
      wasOfferedMed: true,
    });
  };

  useEffect(() => {
    // 1 of 2 places we assign selectedProgram to MED is in this question.
    // if the user back navigates through this question we should nullify selectedProgram
    setSelectedProgram(null);
    // also delete updatedProgram
    const newSurveyAnswers = { ...surveyAnswers };
    delete newSurveyAnswers.updatedProgram;
    setSurveyAnswers(newSurveyAnswers);

    if (currentProgram) {
      trackAnonEvent("b2bEnrollmentAnonRetriageResultPresented", {
        currentProgram,
        eligibleProgram: isAccolade ? "NMPBA" : "MED",
      });
    }
  }, []);

  let onClickSecondaryCta: (() => void) | undefined = () =>
    onClickNext(NoomMedOverviewSelection.SEE_MORE_OPTIONS, {
      wasOfferedMed: true,
    });
  if (currentProgram === "DPP") {
    onClickSecondaryCta = undefined;
  }

  return (
    <ProgramResult
      onClickPrimaryCta={() => handleJoinMed(NoomMedOverviewSelection.NEXT)}
      onClickSecondaryCta={onClickSecondaryCta}
    />
  );
};

export const Q_NOOM_MED_OVERVIEW: QuestionDefinition = {
  id: QUESTION_ID,
  supportedPrograms: ["MED", "NMPBA"],
  shouldShowQuestion: () => true,
  component: NoomMedOverviewQuestion,
};
